import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { CasinoSection } from './CasinoPage.style';
import { CasinoRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { CasinoCollection } from 'src/domains/casino/webview/CasinoGames/CasinoCollection';
import { useCommon } from 'src/domains/common/Common';

interface CasinoPagePropsType {
    currentView: CasinoRouteType;
    isSearchActive: boolean;
    accountView: RightHandSideViewType | null;
}

export const CasinoPage = observer('CasinoPage', (props: CasinoPagePropsType) => {
    const common = useCommon();
    const { currentView, isSearchActive, accountView } = props;
    const appCasinoState = AppCasinoState.get(common);

    return (
        <CasinoSection data-test='casino-page'>
            <LayoutSkeleton
                navigation={false}
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='casino'
            >
                <CasinoCollection
                    appCasinoState={appCasinoState}
                    collection='casino'
                    tabId={currentView.tabId ?? null}
                />
            </LayoutSkeleton>
        </CasinoSection>
    );
});
